module.exports = __webpack_public_path__ + "img/bg-image-2.efdc4e1a.jpg";